import ImageAtom from "@/components/atoms/image/image";
import Paragraph from "@/components/atoms/paragraph/paragraph";
import { useDynamicTrustpilotText } from "@/hooks/use-dynamic-trustpilot-text/use-dynamic-trustpilot-text";

type TrustPilotProps = {
  trustpilotText?: any | null;
  trustpilotImage?: any | null;
};

function TrustPilot({
  trustpilotText,
  trustpilotImage,
}: Readonly<TrustPilotProps>) {
  // Replace placeholders with dynamic Trustpilot data
  const dynamicText = useDynamicTrustpilotText(trustpilotText?.text);

  return (
    <div
      data-testid="trustpilot-container"
      className="flex flex-row py-spacing-m lg:px-spacing-xl px-spacing-m justify-between 
      bg-transparent-overlay lg:rounded-t-radius-xxl lg:rounded-b-none rounded-b-radius-xxl"
    >
      <div
        data-testid="trustpilot-wrapper"
        className=" w-full max-w-none md:max-w-[432px] flex justify-between items-center mx-auto"
      >
        <div
          data-testid="trustpilot-text-container"
          className=" font-body-font text-[14px] leading-[21px] lg:mr-spacing-m md:mr-spacing-l
        mr-spacing-m lg:max-w-none max-w-[261px] w-full"
        >
          {trustpilotText && (
            <Paragraph
              text={dynamicText}
              type=""
              fontBold={trustpilotText.fontBold}
            />
          )}
        </div>
        {trustpilotImage && (
          <div
            data-testid="trustpilot-image-container"
            className="max-w-[140px] w-full"
          >
            <ImageAtom
              image={trustpilotImage.image}
              clickableLink={trustpilotImage.clickableLink}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default TrustPilot;
